import User from '@/utils/user.js';

export const API_TYPES = {
  private: 'private',
  public: 'public',
};

export const getApiData = (apiData, privateRoles = []) => {
  const user = new User();
  const { role } = user;
  const targetRoleName = role.name;
  const hasRoleNameInPrivateRoles = privateRoles.includes(targetRoleName);
  const currentApiType = hasRoleNameInPrivateRoles ? API_TYPES.private : API_TYPES.public;
  const currentApiData = apiData[currentApiType];

  return currentApiData;
};
